



































// Utils
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { buildFilePreview, revokeFilePreview } from '@/utils/documents'
// Types
import CompanyTypes from '@/store/types/CompanyTypes'
// Services
import RenderDocs from '@/services/RenderDocs'

@Component({
})
export default class ModalRenderProtocolized extends Vue {
  file: any = null
  renderModal: any = { showModal: false }

  @Watch('renderModal.showModal')
  load () {
    if (this.renderModal.showModal) this.getRender()
  }

  mounted () {
    this.renderModal = this.$attrs.value
  }

  async getRender () {
    this.loading(true)
    const [error, response] = await RenderDocs.renderProtocolized(this.company.id)
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    revokeFilePreview(this.file)
    this.file = buildFilePreview(response).url
    this.loading(false)
  }

  beforeDestroy () {
    revokeFilePreview(this.file)
  }

  @Getter(`CompanyModule/${CompanyTypes.getters.GET_DATA}`) company: any
  @Action(`CompanyModule/${CompanyTypes.actions.UPDATE_DATA}`) updateCompany: any
  @Action('UPDATE_STATE_LOADING') loading: any
}
